<template>
    <div class="mPage">
        <div class="top">
            <img src="../img/m/m_logo.png" alt="" class="logo">
            <span class="title">{{ $t("message.resource") }}</span>
            <slot></slot>
        </div>
        <div class="content">
            <div class="sourceCon">
                    <div class="firstLine">
                        <img src="../img/sourceimg/cio.png" alt="" v-on:click="toDetail('http://www.chinesecio.com/')">
                        <img src="../img/sourceimg/cti.png" alt="" v-on:click="toDetail('http://www.chinesetest.cn/index.do')">
                    </div>
                    <div class="secondLine">
                        <img src="../img/sourceimg/greatwall.png" alt="" v-on:click="toDetail('https://mooc.chinesecio.com/class_detail.html?clid=235&m_lan=1')">
                        <img src="../img/sourceimg/mangamandarin.png" alt="" v-on:click="toDetail('https://mooc.chinesecio.com/class_detail.html?clid=221&m_lan=1')">
                    </div>
                    <div>
                        <img src="../img/sourceimg/clt_guide.png" alt="" v-on:click="toDetail('http://www.cltguides.com/')">
                        <img src="../img/sourceimg/ciic.png" alt="">
                    </div>
                    <div>
                        <img src="../img/sourceimg/alo7.png" alt="">
                        <img src="../img/sourceimg/yuketang.png" alt="">
                        <img src="../img/sourceimg/popon.png" alt="">
                    </div>
                    <div class="secondLine">
                        <img src="../img/sourceimg/chineseroad.png" alt="">
                        <img src="../img/sourceimg/hanzitiyan.png" alt="">
                        <img src="../img/sourceimg/dragonicon.png" alt="">
                    </div>
                    <div>
                        <img src="../img/sourceimg/rongbaozhai.png" alt="">
                        <img src="../img/sourceimg/cool_panda.png" alt="" v-on:click="toDetail('https://mooc.chinesecio.com/class_detail.html?clid=204&m_lan=1')">
                        <img src="../img/sourceimg/happychinese.png" alt="" v-on:click="toDetail('https://mooc.chinesecio.com/class_detail.html?clid=43&m_lan=1')">
                    </div>
                    <div>
                        <img src="../img/sourceimg/jingdian.png" alt="" v-on:click="toDetail('https://mooc.chinesecio.com/class_detail.html?clid=16&m_lan=1')">
                        <img src="../img/sourceimg/shengdianwa.png" alt="">
                        <img src="../img/sourceimg/yihanyu.png" alt="">
                    </div>
            </div>
        </div>
        <!-- <img src="../img/m/arrow_down.png" alt="" class="arrowDown"> -->
    </div>
</template>

<script>
export default {
    name: 'm_resource',
    components: {
        
    },
    data: function () {
        return {
        }
    },
    computed: {
    },
    methods: {
    toDetail(item) {
        window.open(item)
    }
  },
    watch: {
    },
  mounted() {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mPage {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .top {
        height: 1.4rem;
        line-height: 1.4rem;
        position: relative;
        .logo {
            width: 1.27rem;
            margin: auto 0.34rem;
            vertical-align: middle;
        }
        .title {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            width: 1.93rem;
            display: inline-block;
            text-align: center;
            font-size: 0.46rem;
            white-space: nowrap;
            color: #f3bc65;

        }
        .menu {
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            right: 0.34rem;
            width: 0.51rem;
            vertical-align: middle;
        }
    }
    .content {
        text-align: center;
        .sourceCon {
            background-image: linear-gradient(140deg, 
            rgba(255, 255, 255, 0.36) 0%, 
            #ffffff 100%), 
            linear-gradient(
                rgba(255, 255, 255, 0.6), 
                rgba(255, 255, 255, 0.6));
            background-blend-mode: normal, 
                normal;
            box-shadow: 0px 3px 7px 0px 
                rgba(0, 0, 0, 0.18);
            border-radius: 0.2rem;
            border: solid 0px rgba(255, 255, 255, 0.6);
            padding: 0.1rem 0;
            width: calc(100% - 0.44rem);
            margin: auto;
            div {
                display: flex;
                align-items: center;
                justify-content: center;
                flex: auto;
                margin: 0.4rem 0;
            }
            div:nth-child(1) {
                img:first-child {
                    width: 3.24rem;
                }
                img:last-child {
                    width: 2.5rem;
                }
            }
            div:nth-child(2) {
                img:first-child {
                    width: 2.58rem;
                }
                img:last-child {
                    width: 1.78rem;
                }
            }
            div:nth-child(3) {
                img:first-child {
                    width: 4.12rem;
                }
                img:last-child {
                    width: 0.99rem;
                }
            }
            div:nth-child(4) {
                img:first-child {
                    width: 1.74rem;
                }
                img:nth-child(2) {
                    width: 1.96rem;
                }
                img:last-child {
                    width: 0.62rem;
                }
            }
            div:nth-child(5) {
                img:first-child {
                    width: 2.28rem;
                }
                img:nth-child(2) {
                    width: 0.9rem;
                }
                img:last-child {
                    width: 0.81rem;
                }
            }
            div:nth-child(6) {
                img:first-child {
                    width: 1.79rem;
                }
                img:nth-child(2) {
                    width: 1.91rem;
                }
                img:last-child {
                    width: 0.77rem;
                }
            }
            div:nth-child(7) {
                img:first-child {
                    width: 0.5rem;
                }
                img:nth-child(2) {
                    width: 1.04rem;
                }
                img:last-child {
                    width: 0.63rem;
                }
            }
            img {
                //transform: scale(0.7) translateX(-15%);
                vertical-align: middle;
                margin: 0 0.3rem;
            }
        }

    }
    .arrowDown {
        position: absolute;
        bottom: 0.48rem;
        left: 0;
        right: 0;
        width: 0.28rem;
        margin: auto;
        animation: rotation 0.8s infinite alternate-reverse;
    }
    .secondPage {
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        background-image: url(../img/m/m_bg.png);
        background-size: cover;
    }
}
@-webkit-keyframes rotation {
    from {transform: translateY(0)}
    to   {transform: translateY(5px)}
}
</style>
